export enum CheckListType {
    OT = 1,
    OR = 2,
}
